import {
  buildPaymentSummaryQuery,
  paymentSummaryCardsFromResponse,
} from "@/components/receipt-payment-summary/payment-summary-factory";
import type {
  PaymentSummaryCardView,
  PaymentSummaryResponse,
} from "@/components/receipt-payment-summary/types";

export const YEARLY_NIYAAZ_SUMMARY_QUERY_KEYS = [
  "startDate",
  "endDate",
  "hijriYear",
  "paymentMode",
  "q",
] as const;

export type YearlyNiyaazSummaryQueryKey = (typeof YEARLY_NIYAAZ_SUMMARY_QUERY_KEYS)[number];

export const YEARLY_NIYAAZ_PAYMENT_SUMMARY_PATH = "yearlyNiyaazReceipts/summary/payment-mode";

export function buildYearlyNiyaazSummaryQuery(
  filterValues: Record<string, unknown>
): URLSearchParams {
  return buildPaymentSummaryQuery(filterValues, YEARLY_NIYAAZ_SUMMARY_QUERY_KEYS);
}

/** Always fetch — filters (hijri year, dates, search) narrow the summary. */
export function shouldFetchYearlyNiyaazPaymentSummary(
  _filterValues: Record<string, unknown>
): boolean {
  return true;
}

export function yearlyNiyaazPaymentSummaryCardsFromResponse(
  summary: PaymentSummaryResponse
): PaymentSummaryCardView[] {
  return paymentSummaryCardsFromResponse(summary);
}
